import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from '@app/App';
import { env } from '@config/env';
import '@styles/globals.css';

async function bootstrap(): Promise<void> {
  if (env.enableMocks) {
    const { startMockWorker } = await import('@mocks/browser');
    await startMockWorker();
  }

  const container = document.getElementById('root');
  if (!container) throw new Error('Root element #root not found');

  createRoot(container).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

void bootstrap();
